import { Form } from '@unform/web';
import styled from 'styled-components';
import { shade } from 'polished';
import { ButtonConfirm } from '../../components/ButtonConfirm';
import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 1024px;
  max-height: 90vh;

  display: flex;
  flex-direction: column;
  overflow: hidden;

  background-color: ${colors.surfaceContainerLow};

  @media (max-width: 1199px) {
    min-width: auto;
  }
`;

export const Body = styled.div`
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 24px;

  flex: 1;
  min-height: 0;
  padding: 28px;
  overflow-y: auto;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;

  padding: 16px 28px;
  border-top: 1px solid ${colors.outlineVariant}40;
`;

export const BrowseColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PanelColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  background-color: ${colors.surfaceContainer};
  border: 1px solid ${colors.outlineVariant}40;
  border-radius: ${radius.md};

  padding: 16px;
`;

export const SectionHeader = styled.div`
  padding: 0 4px;
`;

export const SectionTitle = styled.h3`
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurface};

  display: flex;
  align-items: center;
  gap: 8px;

  span {
    color: ${colors.primaryContainer};
  }
`;

export const SearchFormContainer = styled(Form)`
  display: flex;
  align-items: center;

  grid-gap: 8px;

  @media (max-width: 1199px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ExerciseGrid = styled.div`
  height: 440px;
  overflow-y: auto;

  display: grid;
  grid-gap: 10px;

  grid-auto-rows: max-content;
`;

export const LoadMoreButton = styled.button`
  display: block;
  width: 100%;
  padding: 10px;

  background: transparent;
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurfaceVariant};

  &:hover {
    background-color: ${colors.surfaceContainer};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SelectedExerciseCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  padding-bottom: 12px;
  border-bottom: 1px solid ${colors.outlineVariant}40;

  img {
    width: 48px;
    height: 48px;
    border-radius: ${radius.sm};
    object-fit: cover;
  }
`;

export const SelectedExerciseInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;

  strong {
    font-size: 14px;
    color: ${colors.onSurface};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  span {
    font-size: 11px;
    color: ${colors.onSurfaceVariant};
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
`;

export const EmptyPanel = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  padding: 40px 20px;
  text-align: center;

  color: ${colors.onSurfaceVariant};

  span {
    font-size: 13px;
    max-width: 240px;
  }
`;

export const ParamsFormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  flex: 1;

  overflow-y: auto;

  & > * {
    margin-bottom: 10px;
  }
`;

export const ParamsActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-gap: 12px;
`;

export const BackButton = styled.button`
  height: 44px;
  padding: 0 20px;

  background-color: transparent;
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.DEFAULT};

  color: ${colors.onSurfaceVariant};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${shade(0.7, colors.onSurfaceVariant)};
  }
`;

export const Submit = styled(ButtonConfirm)`
  width: auto;
  height: 44px;
  padding: 0 24px;
  border-radius: ${radius.DEFAULT};
`;
